import styled from "styled-components";
import { Container, Store, wrap, Wrapper } from 'AppReact';
import { SectionLabel } from '../../../common/atoms';
import { FieldWrapper } from '../../../common/wrappers';
import device from "utils/device";
import { SolidButton } from '../../../common/molecules';
import { Divider, DisableWraper, ButtonWraper } from './wrappers';
import {
    Occupants,
    MoveInInformation,
    Pets,
    Vehicles,
    CurrentResidency,
    EmploymentInformation,
    EmergencyContact,
    UploadDocuments,
} from './../mainContainers';

import { tabsArray } from "../../../constants";



const template = styled.div`
    width: 336px;
    padding: 0 24px;
    margin: 0 auto;

    @media ${device.tablet} {
        width: 594px;
    }
`



export const definition = {
    name: "Review",
    props: { language: Store, isEditMode: Store, property: Store, occupants: Store, havePets: Store, moveInInformation: Store,
        pets: Store, vehicles: Store, currentResidency: Store, employmentInformations: Store, emergencyContacts: Store, uploadedDoc: Store, tabsArray },
    elements: [
        {
            wrapper: DisableWraper,
            name: "Wrapper",
            elements: [
                {
                    component: wrap(SectionLabel, Wrapper(template)),
                    name: 'SectionTitle',
                    displayValue: ({ language }) => `${language?.review || 'Review'}`,
                    bindings: ({ }) => ({})
                },
                {
                    component: Occupants,
                    name: 'Occupants',
                    bindings: () => { }
                },
                {
                    component: Divider,
                    name: 'OccupantsDivider',
                    bindings: () => { }
                },
                {
                    component: MoveInInformation,
                    name: 'MoveInInformation',
                    bindings: () => { }
                },
                {
                    component: Divider,
                    name: 'MoveInDivider',
                    bindings: () => { }
                },
                {
                    component: Pets,
                    name: 'Pets',
                    bindings: () => { }
                },
                {
                    component: Divider,
                    name: 'PetsDivider',
                    bindings: () => { }
                },
                {
                    component: Vehicles,
                    name: 'Vehicles',
                    bindings: () => { }
                },
                {
                    component: Divider,
                    name: 'VehiclesDivider',
                    bindings: () => { }
                },
                {
                    component: CurrentResidency,
                    name: 'CurrentResidency',
                    bindings: () => { }
                },
                {
                    component: Divider,
                    name: 'ResidencyDivider',
                    bindings: () => { }
                },
                {
                    component: EmploymentInformation,
                    name: 'EmploymentInformation',
                    bindings: () => { }
                },
                {
                    component: Divider,
                    name: 'EmploymentDivider',
                    bindings: () => { }
                },
                {
                    component: EmergencyContact,
                    name: 'EmergencyContact',
                    bindings: () => { }
                },
                {
                    component: Divider,
                    name: 'ContactDivider',
                    bindings: () => { }
                },
            ]
        },
        {
            component: wrap(SolidButton, ButtonWraper),
            name: 'Button',
            bindings: ({isEditMode, tabsArray, language, ...props}) => {
                const errorProps = { tabsArray, props }
                return ({ errorProps, isEditMode, title: `${isEditMode ? 'Update Application' : 'Submit Application'}`, big: true, disabled: false })
            },
        },
    ],
}

const Review = Container(definition)

export default Review;
